import * as React from 'react';
import {withRouter} from 'react-router';
import Col from 'reactstrap/lib/Col';
import Switch from 'react-switch';
import {IHistory} from '../../interfaces';
import {Icon} from '../reusableComponents/Icon';
import {OrgModel} from '../../model/OrgModel';
import {DeleteOrganizationDialog} from './DeleteOrganizationDialog';

export interface IListItemProps {
    instance?: OrgModel;
    index?: number;
    listItemProp?: string;
    onClick?: Function;
    className?: string;
    history?: IHistory;
}

interface IListItemState {
    open: boolean;
    isOrgActive: boolean;
    oldOrgStatus: boolean;
}

export class ListItemImpl extends React.Component<IListItemProps, IListItemState> {
    constructor(props: IListItemProps) {
        super(props);
        this.state = {open: false, isOrgActive: props.instance.props.IsActive, oldOrgStatus: props.instance.props.IsActive};
        this.orgActiveSwitchChange = this.orgActiveSwitchChange.bind(this);
    }

    orgActiveSwitchChange = (status, isWindowToOpen?: boolean) => {
        this.setState({
            isOrgActive: status
        }, () => {
            this.setState({
                open: isWindowToOpen
            });
        });
    }

    public render() {
        const {history, instance} = this.props;
        return <div className="list-item">
                <DeleteOrganizationDialog
                history={this.props.history}
                onClose={() => this.orgActiveSwitchChange(this.state.oldOrgStatus, false)}
                open={this.state.open}
                orgStatus={this.state.isOrgActive}
                instance={instance}/>
            <Col onClick={() => history.push(`/org/${instance.props.id}`)} className="name" sm={5}>
                {instance.props.OrganizationName}
            </Col>
            <Col onClick={() => history.push(`/org/${instance.props.id}`)} className="date_created" sm={3}>
                {instance.props.CreatedAt || 'NA'}
            </Col>
            <div className="mobile-container col-sm-4">
                <Col
                    onClick={() => history.push(`/org/edit/${instance.props.id}`)}
                    className="edit org-edit"
                    sm={6}>
                    <Icon icon="pencil-alt"/>
                </Col>
                <Col
                    className="trash" sm={6}>
                    <Switch className='' onChange={(e) => this.orgActiveSwitchChange(e, true)} checked={instance.props.IsActive}/>
                </Col>
            </div>
        </div>;
    }
}

export const ListItem = withRouter(ListItemImpl as any);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Organization/ListItems.tsx